import { graphql, useStaticQuery } from 'gatsby';

type ShippingRateQuery = {
  contentfulSiteMetadata: {
    standardShippingRates: {
      amount: number;
      minWeight: number;
      maxWeight: number | null;
    }[];
  };
};

export function useShippingRates() {
  const data = useStaticQuery<ShippingRateQuery>(graphql`
    query ShippingRates {
      contentfulSiteMetadata(slug: { eq: "site-metadata" }) {
        standardShippingRates {
          amount
          minWeight
          maxWeight
        }
      }
    }
  `);
  if (!data?.contentfulSiteMetadata) {
    throw new Error('No shipping rates found in Contentful!');
  }

  return data.contentfulSiteMetadata.standardShippingRates;
}
